"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blockSpacingMapping = {
    small: "5%",
    medium: "7.5%",
    large: "10%",
};
exports.default = blockSpacingMapping;
